/*
 * Copyright (c) 2024 Cozy Intellect Inc.
 * File Path: packages/sharedlib/src/utils/error.util.ts
 */

export function isErrorWithMessage(error: unknown): error is { message: string } {
  return typeof (error as { message?: unknown }).message === 'string';
}
